import assets from "app/assets";
import config from "config";
import { gsap } from "gsap";
import { BaseTexture, Container, DEG_TO_RAD, Graphics, Sprite, Text, TextStyle, Texture } from "pixi.js";
import tools from "tools";
import Stars from "./stars";
const PIC_SIZE = 65;
export default class DefaultObjectifBubble extends Container {
  constructor(colorData, size, id) {
    super();
    tools.autobind(this);
    if (id == 4) {
      this._color = 0xffffff;
      this._texture = assets.textures.universalBulle.texture;
      this._universal = true;
    } else {
      this._color = colorData.color;
      this._texture = assets.textures[colorData.texture].texture;
      this._label = colorData.label;
    }
    this._size = size;
    this._build();
  }
  _build() {
    this._value = 0;
    this._sprite = new Sprite(this._texture);
    this._sprite.tint = this._color;
    this._sprite.anchor.set(.5);
    this._sprite.y = -30;
    this._sprite.width = this._size;
    this._sprite.height = this._size;
    this.addChild(this._sprite);
    const style = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 28,
      fill: '#2c5f9a'
    });
    this._nb = new Text("", style);
    this._nb.anchor.set(.5);
    this.addChild(this._nb);
    this._check = new Sprite(assets.textures.check.texture);
    this._check.tint = 0x6be11a;
    this._check.anchor.set(.5);
    this._check.scale.set(.7);
    this._check.visible = false;
    this.addChild(this._check);
    this._rays = new Sprite(assets.textures.objectifRays.texture);
    this._rays.tint = this._color;
    this._rays.anchor.set(.5);
    this._rays.scale.set(.1);
    this._rays.y = -30;
    this._rays.visible = false;
    this.addChild(this._rays);
    this.stars = new Stars(8, {
      x: 0,
      y: 0,
      w: 30,
      h: 60
    });
    this.stars.loop = true;
    // this.stars.debug = true;
    this.stars.scaleMax = .3;
    this.stars.y = -15;
    this.addChild(this.stars);
    this.y = 30;
  }
  set skin(data) {
    this._themeId = data.id;
    this._color = data.tint;
    this._texture = assets.textures[data.texture].texture;
    this._sprite.texture = this._texture;
    this._sprite.tint = this._color;
    this._rays.tint = this._color;
  }
  glow(val) {
    this._rays.tint = val;
  }
  set value(val) {
    this._value = val;
    this._nb.text = val;
    if (this._value == 0) {
      this._nb.visible = false;
      this._check.visible = true;
      this._check.scale.set(.2);
      gsap.to(this._check.scale, {
        duration: .5,
        x: .7,
        y: .7,
        ease: "back.out(10)"
      });
      this.stars.show();
      this._sprite.alpha = .6;
    } else {
      this._nb.visible = true;
      this._check.visible = false;
      this.tween && this.tween.kill();
      this.tween2 && this.tween2.kill();
      this.tween3 && this.tween3.kill();
      this.tween4 && this.tween4.kill();
      this.scale.set(1.4);
      this.tween = gsap.to(this.scale, {
        duration: .25,
        x: 1,
        y: 1
      });
      this._rays.visible = true;
      this._rays.alpha = 1;
      this._rays.rotation = 0;
      this.tween2 = gsap.to(this._rays.scale, {
        duration: .25,
        x: .2,
        y: .2
      });
      this.tween3 = gsap.to(this._rays, {
        delay: .25,
        duration: 1,
        rotation: tools.range(-30, 30) * DEG_TO_RAD
      });
      this.tween4 = gsap.to(this._rays, {
        delay: .25,
        duration: 1,
        alpha: 0,
        onComplete: () => {
          this._rays.visible = false;
        }
      });
      this.stars.hide();
    }
  }
  get value() {
    return this._value;
  }
  get label() {
    return this._label;
  }
  get universal() {
    return this._universal;
  }
}
